export const isValidUrl = (value) => {
    if (!value) return true;
    return /^(?:(?:(?:https?):)?\/\/)(?:\S+(?::\S*)?@)?(?:|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
}

export const isValidMaxRows = (maxRows, value) => {
    let text = '';
    if (value) {
        text = value.replaceAll('\n', ';');
    }
    return (text.match(/;/g) || []).length <= maxRows;
}